// Module
var code = "<template> <ux-dialog> <ux-dialog-header> <h2>Authentication Required</h2> </ux-dialog-header> <ux-dialog-body> Please log in to continue. </ux-dialog-body> <ux-dialog-footer> <button class=\"btn btn-primary\" click.trigger=\"controller.ok()\">Ok</button> </ux-dialog-footer> </ux-dialog> </template> ";
// Exports
export default code;